import { PageContainer, TopBarPageContainer } from "@components/PageContainer";
import { PermissionedRoutes } from "@components/PermissionedRoutes";
import { TopBar } from "@components/TopBar";
import { useUserConfiguration } from "@hooks/useUserConfiguration";
import { Button } from "@narmi/design_system";
import { TEAM_ROUTES } from "@pages/teams/routes";
import { useState } from "react";
import { RouteObject } from "react-router-dom";

export const MESSAGE_CONFIGURATION_ROUTES: RouteObject[] = [
  {
    element: <PermissionedRoutes requiredPermissions={["indigo.view_message"]} />,
    children: [
      {
        index: true,
        async lazy() {
          const { MessageSettings } = await import("./MessageSettings");
          return {
            element: (
              <TopBarPageContainer title={["Configuration", "Messages"]} maxWidth="624px">
                <MessageSettings />
              </TopBarPageContainer>
            ),
          };
        },
      },
      {
        path: "request_types",
        async lazy() {
          const { RequestTypesList } = await import("./request_types/RequestTypesList");
          const { AddEditModal } = await import("./request_types/AddEditModal");

          return {
            Component() {
              const { permissions } = useUserConfiguration();
              const [isAddRequestTypeFormOpen, setIsAddRequestTypeFormOpen] = useState(false);

              return (
                <>
                  <TopBar.Compact>
                    <TopBar.Breadcrumb>Configuration</TopBar.Breadcrumb>
                    <TopBar.Breadcrumb to="/configuration/messages">Messages</TopBar.Breadcrumb>
                    <TopBar.Breadcrumb>Request types</TopBar.Breadcrumb>
                    <TopBar.Spacer />
                    {permissions.includes("indigo.add_threadcategory") ? (
                      <Button
                        size="xs"
                        label="Add request type"
                        onClick={() => setIsAddRequestTypeFormOpen(true)}
                      />
                    ) : null}
                  </TopBar.Compact>
                  <PageContainer>
                    <RequestTypesList />
                    <AddEditModal
                      isOpen={isAddRequestTypeFormOpen}
                      handleClose={() => setIsAddRequestTypeFormOpen(false)}
                    />
                  </PageContainer>
                </>
              );
            },
          };
        },
      },
      {
        path: "saved_replies",
        async lazy() {
          const { SavedRepliesList } = await import("./saved_replies/SavedRepliesList");
          const { AddEditModal } = await import("./saved_replies/AddEditModal");

          return {
            Component() {
              const { permissions } = useUserConfiguration();
              const [isAddReplyFormOpen, setIsAddReplyFormOpen] = useState(false);

              return (
                <>
                  <TopBar.Compact>
                    <TopBar.Breadcrumb>Configuration</TopBar.Breadcrumb>
                    <TopBar.Breadcrumb to="/configuration/messages">Messages</TopBar.Breadcrumb>
                    <TopBar.Breadcrumb>Saved replies</TopBar.Breadcrumb>
                    <TopBar.Spacer />
                    {permissions.includes("support.add_savedreply") ? (
                      <Button
                        size="xs"
                        label="Add saved reply"
                        onClick={() => setIsAddReplyFormOpen(true)}
                      />
                    ) : null}
                  </TopBar.Compact>
                  <PageContainer>
                    <SavedRepliesList />
                    <AddEditModal
                      isOpen={isAddReplyFormOpen}
                      handleClose={() => setIsAddReplyFormOpen(false)}
                    />
                  </PageContainer>
                </>
              );
            },
          };
        },
      },
      {
        path: "teams",
        element: <PermissionedRoutes requiredPermissions={["indigo.view_team"]} />,
        children: TEAM_ROUTES,
      },
    ],
  },
];
